import {OperationModesEnum} from '../../../stores/common/operation-modes.store';
import {Injectable}         from '@angular/core';
import {CropTypeStore}      from '../../../stores/base-data/crop.types.store';

@Injectable()
export class NFertilizationCommonEntryService {
  constructor(private cropTypeStore: CropTypeStore) {
  }

  public isOperationModeGroupMapButNotConst(operationModeKey: OperationModesEnum): boolean {
    if (!operationModeKey) {
      return false;
    }
    return operationModeKey === OperationModesEnum.ApplicationMap
      || operationModeKey === OperationModesEnum.ApplicationMapAbsolute
      || operationModeKey === OperationModesEnum.NfTargetMapPerPlan;
  }

  public getThreshold(growStage: number | undefined, cropKey: number | undefined, avgNMin: number | undefined): number | undefined {
    let result = 0;
    if (!Number.isFinite(growStage) || !Number.isFinite(cropKey)) {
      return undefined;
    }
    const platformSpecificCrop = this.cropTypeStore.CropTypes.find((ct) => ct.CropKey === cropKey && ct.FarmId === -1);
    if (!platformSpecificCrop) {
      return undefined;
    }
    const thresholds = JSON.parse(platformSpecificCrop.Thresholds);
    const keys = Object.keys(thresholds);
    if (keys.length <= 0) {
      return undefined;
    }
    if (keys.length === 1) {
      return thresholds[keys[0]];
    }
    const firstKey = keys[0];
    const lastKey = keys[keys.length - 1];
    if (+firstKey > growStage) {
      result = thresholds[firstKey];
    } else if (+lastKey < growStage) {
      result = thresholds[lastKey];
    } else {
      result = thresholds[growStage.toString()];
    }
    if (avgNMin !== undefined) {
      result = Math.min(result, avgNMin * 0.5);
    }
    return result;
  }
}
